/** @format */

import React, { useEffect, useState, useRef } from "react";
import TableForm from "./tableForm";
import "../App.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

const Form1 = () => {
  const [tableData, setTableData] = useState([]);

  const onTableDataChange = (updatedTableData) => {
    setTableData(updatedTableData);
  };

  const [formData, setFormData] = useState({
    doc_type: "1",
    ref_field: null,
    str_id: null,
    supplier_name: null,
    supplier_info: null,

    requester_id: null,
    req_date: null,
    approver_1: null,
    approver_2: null,
    approver_3: null,
    approver_4: null,
    approver_5: null,
    approver_6: null,
    approver_7: null,
    approver_8: null,
    appro_1: null,
    appro_2: null,
    appro_3: null,
    appro_4: null,
    appro_5: null,
    appro_6: null,
    appro_7: null,
    appro_8: null,
    // ...
  });

  const handleSubmit = async (e) => {
    // e.preventDefault();

    // Make a fetch() request to submit the form data to the backend.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/formSubmit`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(combinedFormData),
      }
    );

    // Check the response status code.
    if (response.status === 200) {
      // Success!
      document.getElementById("btn-submit-form").disabled = true;

      toast.current.show({
        severity: "success",
        summary: "succès",
        detail: "Demande envoyée",
      });
    } else {
      // Error!
      alert("An error occurred while submitting the form data.");
    }
  };

  //get approvers ----------------------------------------------

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  //get documents -------------------------------------------

  const [docs, setDocs] = useState([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
    let docLen = docs.length;

    if (docLen > 0) {
      setIsNotEmpty(true);
    }
  };

  // console.log(formData);

  //initialize approvers status for the request------------
  const [currentDocIsSelected, setCurrentDocIsSelected] = useState(false);
  const [currentDoc, setCurrentDoc] = useState([]);
  const getCurrentDoc = () => {
    // console.log(isNotEmpty);
    if (docs.length !== 0) {
      const current = docs.filter(
        (doc) => doc.doc_type_id == formData.doc_type
      );
      setCurrentDoc(current);
      setCurrentDocIsSelected(true);
    }
  };

  // console.log(currentDocIsSelected);

  // console.log(formData);
  const initializeApproversState = () => {
    if (currentDoc.length > 0) {
      const firstDoc = currentDoc;
      const currDoc = firstDoc[0];

      const currDocArray = Object.entries(currDoc);

      let filteredDocArray = currDocArray.filter(
        (innerArr) =>
          innerArr[0] !== "doc_type_id" && innerArr[0] !== "doc_tittle"
      );

      // console.log(filteredDocArray);

      let updatedFormData = { ...formData };
      for (let i = 0; i < filteredDocArray.length; i++) {
        const key = filteredDocArray[i][0];
        const value = filteredDocArray[i][1];
        const fdKey = Object.entries(formData);
        for (let j = 0; j < fdKey.length; j++) {
          if ((value === 0) | (value === null)) {
            if (fdKey[j][0] == key) {
              updatedFormData[key] = null;
            }
          } else {
            updatedFormData[key] = false;
          }
        }
      }
      setFormData(updatedFormData);
    }
  };

  // console.log(formData);

  // console.log(formData.approver_1);

  //--------------------------------------------------------

  const [name, setName] = useState("");
  const [requesterId, setRequesterId] = useState("");

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setRequesterId(parsRes.emp_id);
      setRequesterStr(parsRes.asigned_str);
      setFormData({ ...formData, str_id: parsRes.asigned_str });
    } catch (err) {
      console.error(err.message);
    }
  }

  const setDefaultApprovers = () => {
    let firstApprover = null;
    for (let i = 0; i < docs.length; i++) {
      setFormData({
        ...formData,
        appro_1: docs[i].approver_1,
        appro_2: docs[i].approver_2,
        appro_3: docs[i].approver_3,
        appro_4: docs[i].approver_4,
        appro_5: docs[i].approver_5,
        appro_6: docs[i].approver_6,
        appro_7: docs[i].approver_7,
        appro_8: docs[i].approver_8,
      });
    }
  };

  useEffect(() => {
    getName();
    fetchDocs();
    fetchAppro();
    getCurrentDoc();
  }, []);

  useEffect(() => {
    getCurrentDoc();
    fetchStr();
    setDefaultApprovers();
  }, [docs]);

  useEffect(() => {
    initializeApproversState();
  }, [currentDoc]);

  const combinedFormData = {
    ...formData,
    tableData,
  };
  useEffect(() => {
    setFormData({ ...formData, requester_id: requesterId });
  }, [combinedFormData.ref_field]);

  const [currentDate, setCurrentDate] = useState(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setFormData({ ...formData, req_date: currentDate });
  }, [currentDate]);

  const dataValidation = () => {
    if ((formData.ref_field == "") | (formData.supplier_name == "")) {
      document.getElementById("btn-submit-form").disabled = true;
    } else {
      document.getElementById("btn-submit-form").disabled = false;
    }
  };

  useEffect(() => {
    dataValidation();
  }, [formData.ref_field, formData.supplier_name]);

  const [reqCount, setReqCount] = useState([]);
  const fetchReqCount = async (strId) => {
    const url = `/api/strReqCount?strId=${strId}`;

    const response = await fetch(url, {
      method: "GET",
      headers: { token: localStorage.token },
    });

    const data = await response.json();

    setReqCount(data);
  };
  const [requesterStr, setRequesterStr] = useState("");

  const [str, setStr] = useState([]);
  // fetch the list of structures from the database, the data includes str_id, str_name, str_parent, str_head
  const fetchStr = async () => {
    const response = await fetch("/api/structures");
    const data = await response.json();

    setStr(data);
  };

  // display structure title from structure id -------------------

  function getStrName(str, assignedStr) {
    // Find object in strData that matches assigned_str
    const strTitle = str.find((obj) => obj.str_id === assignedStr);

    // Return str_name if match found, otherwise return empty string
    return strTitle ? strTitle.str_name : "";
  }

  // -------------------------------------------------------------

  // Document reference generation ---------------------------------

  function generateAbbreviation(str) {
    // Split the string into words
    var words = str.split(" ");

    // If it's a single word, take the first three characters
    if (words.length === 1) {
      return str.substring(0, 3).toUpperCase();
    }

    // If it's a multi-word sentence, take the first character of each word
    var abbreviation = words
      .map((word) => word.charAt(0).toUpperCase())
      .join("");

    return abbreviation;
  }

  function generateRef() {
    const currentYear = new Date().getFullYear();
    const abbreviation = generateAbbreviation(getStrName(str, requesterStr));
    const ref = `UDES-${abbreviation}-${String(
      Number(reqCount.count) + 1
    ).padStart(3, "0")}-${currentYear}`;
    setFormData({ ...formData, ref_field: ref });
  }

  // confirmation dialog -------------------------------------------
  useEffect(() => {
    generateRef();
  }, [reqCount]);

  useEffect(() => {
    if (
      requesterStr !== null &&
      requesterStr !== "" &&
      requesterStr !== undefined
    ) {
      fetchReqCount(parseInt(requesterStr));
    }
  }, [requesterStr]);

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "demande envoyée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Confirmer l'envoie de la demande?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleSubmit(),
      reject,
    });
  };

  // ------------------------------------------------------------

  return (
    <div className="submit-input-page">
      <form id="form-submit" className="" onSubmit={handleSubmit}>
        <div className="mb-5 mt-5">
          <h5 className="h3 text-center ">Bon de Commande</h5>
        </div>
        <div className="infoBlock mb-5">
          <div className="input-group mb-3">
            <span className="input-group-text" htmlFor="ref_field">
              No. :
            </span>
            <input
              className="form-control"
              type="text"
              id="ref_field"
              name="ref_field"
              value={formData.ref_field}
              onChange={(e) =>
                setFormData({ ...formData, ref_field: e.target.value })
              }
            />
          </div>

          <div className="input-group bm-3">
            <span className="input-group-text" htmlFor="">
              Nom du fournisseur:
            </span>
            <input
              className="form-control"
              type="text"
              id="supplier_name"
              name="supplier_name"
              value={formData.supplier_name}
              onChange={(e) =>
                setFormData({ ...formData, supplier_name: e.target.value })
              }
            />
          </div>

          <div className="input-group bm-3">
            <span className="input-group-text" htmlFor="">
              Adresse:
            </span>
            <input
              className="form-control"
              type="text"
              id="supplier_info"
              name="supplier_info"
              value={formData.supplier_info}
              onChange={(e) =>
                setFormData({ ...formData, supplier_info: e.target.value })
              }
            />
          </div>
        </div>

        <div className="">
          <TableForm onTableDataChange={onTableDataChange} />
        </div>

        <div>
          <label className="" htmlFor="">
            Approbation par le Directeur *
          </label>
        </div>

        {/* <button id='btn-submit-form' type='submit'>
          Submit
        </button> */}
      </form>
      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />

      <div className="p-confirm-dialog	">
        <ConfirmDialog className="p-confirm-dialog" />
      </div>

      <Button
        id="btn-submit-form"
        onClick={confirm1}
        icon="pi pi-check"
        label="soumettre"
        className="mr-2 btn btn-primary btn-submit-form"
      ></Button>

      {/* confirmation dialog ----------------------------------------- */}
      <Toast ref={toast} />
    </div>
  );
};

export default Form1;
